export default "__VITE_ASSET__d0c946ba__"